













import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.specificities.shop.shopWindowWidth",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["COMMERCIAL"].indexOf(this.getPropertyType()) !== - 1;
        },
        shopWindowWidth: function(): number {
            return Number(this.$store.getters["FormModule/getValue"](this.pathInStore));
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(shopWindowWidth: number): void {
            if (shopWindowWidth === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": shopWindowWidth});
            }
        }
    },
});

